(() => {
  const NOTES = {
    G3: [196.00, "5", "down", null], A3: [220.00, "6", "down", 0], B3: [246.94, "7", "down", 180], C4: [261.63, "1", "", 324],
    D4: [293.66, "2", "", 36], E4: [329.63, "3", "", 288], F4: [349.23, "4", "", 72], G4: [392.00, "5", "", 252],
    A4: [440.00, "6", "", 108], B4: [493.88, "7", "", 216], C5: [523.25, "1", "up", 144]
  };
  const NS = "http://www.w3.org/2000/svg";
  const $ = (id) => document.getElementById(id);
  const mk = (tag, a, p) => { const e = document.createElementNS(NS, tag); for (const k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; };
  const TONGUE = "M-23 -196 L-23 -104 Q-23 -90 -13 -88 Q-6 -82 0 -84 Q6 -82 13 -88 Q23 -90 23 -104 L23 -196 Z";
  const CENTER = "M200 146 C232 146 250 170 250 198 C250 226 232 250 200 252 C168 250 150 226 150 198 C150 170 168 146 200 146 Z";
  let drumColor = "#1d7a74";

  // ----- Tambour vu de dessus -----
  const playable = {};
  function topDrum(svg, interactive) {
    svg.innerHTML = "";
    const id = svg.id;
    const defs = mk("defs", {}, svg);
    const cp = mk("clipPath", { id: id + "-c" }, defs); mk("circle", { cx: 200, cy: 200, r: 182 }, cp);
    const gr = mk("radialGradient", { id: id + "-g", cx: "36%", cy: "30%", r: "80%" }, defs);
    mk("stop", { offset: "0", "stop-color": shade(drumColor, 0.35) }, gr); mk("stop", { offset: "1", "stop-color": shade(drumColor, -0.3) }, gr);
    mk("circle", { cx: 200, cy: 200, r: 191, fill: shade(drumColor, -0.4) }, svg);
    mk("circle", { cx: 200, cy: 200, r: 182, fill: "url(#" + id + "-g)" }, svg);
    const g = mk("g", { "clip-path": "url(#" + id + "-c)" }, svg);
    Object.entries(NOTES).forEach(([key, [f, label, mark, angle]]) => {
      const t = mk("g", { class: "t" + (interactive ? " live" : "") }, g); let x = 200, y = 200;
      if (angle === null) mk("path", { d: CENTER, style: "fill:" + shade(drumColor, 0.08) }, t);
      else { mk("path", { d: TONGUE, transform: "translate(200 200) rotate(" + angle + ")", style: "fill:" + shade(drumColor, 0.08) }, t); const a = (angle - 90) * Math.PI / 180; x = 200 + Math.cos(a) * 132; y = 200 + Math.sin(a) * 132; }
      const tx = mk("text", { x, y, class: "num" }, t); tx.textContent = label;
      if (mark) mk("circle", { cx: x, cy: y + (mark === "down" ? 17 : -17), r: 2.6, class: "dot" }, t);
      if (interactive) {
        playable[key] = { el: t, x, y };
        t.setAttribute("tabindex", "0"); t.setAttribute("role", "button"); t.setAttribute("aria-label", "Note " + label + (mark === "down" ? " grave" : mark === "up" ? " aiguë" : ""));
        const go = (ev) => { ev.preventDefault(); hit(key); };
        t.addEventListener("pointerdown", go); t.addEventListener("keydown", (ev) => { if (ev.key === "Enter" || ev.key === " ") go(ev); });
      }
    });
    if (interactive) { const ring = mk("circle", { class: "ring", r: 30, opacity: 0, id: id + "-ring" }, svg); }
  }

  function shade(hex, amt) {
    const n = parseInt(hex.slice(1), 16); let r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    const f = (c) => Math.round(amt >= 0 ? c + (255 - c) * amt : c * (1 + amt));
    return "#" + [f(r), f(g), f(b)].map((v) => v.toString(16).padStart(2, "0")).join("");
  }

  // ----- Tambour en perspective (héros) -----
  function heroDrum() {
    const svg = $("hero-drum"); svg.innerHTML = "";
    const cx = 200, cy = 150, rx = 150, ry = 70, h = 58, k = ry / 182;
    const defs = mk("defs", {}, svg);
    const side = mk("linearGradient", { id: "side", x1: "0", x2: "1", y1: "0", y2: "0" }, defs);
    [[0, -0.55], [0.35, -0.15], [0.6, -0.25], [1, -0.6]].forEach(([o, a]) => mk("stop", { offset: o, "stop-color": shade(drumColor, a) }, side));
    const topg = mk("radialGradient", { id: "topg", cx: "35%", cy: "25%", r: "85%" }, defs);
    mk("stop", { offset: "0", "stop-color": shade(drumColor, 0.32) }, topg); mk("stop", { offset: "1", "stop-color": shade(drumColor, -0.28) }, topg);
    const cp = mk("clipPath", { id: "topclip" }, defs); mk("ellipse", { cx, cy, rx: rx - 4, ry: ry - 2 }, cp);
    mk("ellipse", { cx: 200, cy: 262, rx: 196, ry: 26, fill: "#2a1a10", opacity: 0.55 }, svg);
    mk("rect", { x: 0, y: 236, width: 400, height: 64, fill: "#6d4528" }, svg);
    mk("rect", { x: 0, y: 236, width: 400, height: 3, fill: "#a87148", opacity: 0.6 }, svg);
    mk("ellipse", { cx, cy: cy + h + 6, rx: rx + 6, ry: ry * 0.75, fill: "#1a0f09", opacity: 0.55 }, svg);
    mk("path", { d: `M${cx - rx} ${cy} L${cx - rx} ${cy + h} A${rx} ${ry} 0 0 0 ${cx + rx} ${cy + h} L${cx + rx} ${cy} Z`, fill: "url(#side)" }, svg);
    [[-0.62, 1], [0.08, 1.07], [0.68, 1]].forEach(([fx, fy]) => mk("ellipse", { cx: cx + fx * rx, cy: cy + h + ry * 0.62 * fy, rx: 11, ry: 5, fill: "#111" }, svg));
    mk("ellipse", { cx, cy, rx, ry, fill: "url(#topg)" }, svg);
    const g = mk("g", { "clip-path": "url(#topclip)" }, svg);
    const inner = mk("g", { transform: `translate(${cx} ${cy}) scale(${rx / 182} ${k}) translate(-200 -200)` }, g);
    Object.values(NOTES).forEach(([f, label, mark, angle]) => {
      if (angle === null) mk("path", { d: CENTER, fill: shade(drumColor, 0.06), stroke: "#0b3c38", "stroke-width": 2.6 }, inner);
      else mk("path", { d: TONGUE, transform: `translate(200 200) rotate(${angle})`, fill: shade(drumColor, 0.06), stroke: "#0b3c38", "stroke-width": 2.6 }, inner);
    });
    Object.values(NOTES).forEach(([f, label, mark, angle]) => {
      let x = 200, y = 200; if (angle !== null) { const a = (angle - 90) * Math.PI / 180; x = 200 + Math.cos(a) * 132; y = 200 + Math.sin(a) * 132; }
      const px = cx + (x - 200) * rx / 182, py = cy + (y - 200) * k;
      const t = mk("text", { x: px, y: py, "font-family": "Instrument Serif, Georgia, serif", "font-size": 15, fill: "#e2bf7b", "text-anchor": "middle", "dominant-baseline": "central" }, svg); t.textContent = label;
    });
    mk("ellipse", { cx: cx - 40, cy: cy - 30, rx: 70, ry: 18, fill: "#fff", opacity: 0.09 }, svg);
    mk("line", { x1: 238, y1: 291, x2: 352, y2: 270, stroke: "#8a5532", "stroke-width": 5, "stroke-linecap": "round" }, svg);
    mk("circle", { cx: 356, cy: 269, r: 8, fill: "#151515" }, svg);
    mk("line", { x1: 222, y1: 284, x2: 336, y2: 259, stroke: "#8a5532", "stroke-width": 5, "stroke-linecap": "round" }, svg);
    mk("circle", { cx: 340, cy: 258, r: 8, fill: "#151515" }, svg);
  }

  function bokeh() {
    const svg = $("bokeh"); const pts = [[40, 50, 16], [96, 30, 10], [150, 70, 12], [330, 40, 18], [360, 110, 9], [280, 80, 7], [70, 130, 8], [210, 30, 6], [250, 120, 11], [20, 190, 7], [380, 200, 10], [120, 170, 6]];
    pts.forEach(([x, y, r]) => mk("circle", { cx: x, cy: y, r, fill: "#ffe2a8", opacity: (0.18 + (r % 5) * 0.06).toFixed(2) }, svg));
  }

  // ----- Son -----
  let ac = null, out = null, rev = null;
  function tone(freq) {
    if (!ac) {
      ac = new (window.AudioContext || window.webkitAudioContext)(); out = ac.createGain(); out.gain.value = 0.8; out.connect(ac.destination);
      rev = ac.createConvolver(); const len = Math.floor(ac.sampleRate * 2.4), ir = ac.createBuffer(2, len, ac.sampleRate);
      for (let c = 0; c < 2; c++) { const d = ir.getChannelData(c); for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3.2); }
      rev.buffer = ir; const w = ac.createGain(); w.gain.value = 0.22; rev.connect(w); w.connect(out);
    }
    if (ac.state === "suspended") ac.resume();
    const t = ac.currentTime, env = ac.createGain();
    env.gain.setValueAtTime(0.0001, t); env.gain.exponentialRampToValueAtTime(0.42, t + 0.006); env.gain.exponentialRampToValueAtTime(0.0001, t + 3.2);
    env.connect(out); env.connect(rev);
    [[1, 1, 3.2], [2, 0.16, 1.4], [2.98, 0.05, 0.6]].forEach(([m, a, d]) => { const o = ac.createOscillator(), g = ac.createGain(); o.frequency.value = freq * m; g.gain.setValueAtTime(a, t); g.gain.exponentialRampToValueAtTime(0.0001, t + d); o.connect(g); g.connect(env); o.start(t); o.stop(t + d + 0.05); });
  }

  // ----- Mini-démo guidée -----
  const TUNE = ["C4", "C4", "C4", "D4", "E4", "D4", "C4", "E4", "D4", "D4", "C4"];
  let step = -1;
  const meter = $("meter");
  function renderMeter() { meter.innerHTML = ""; TUNE.forEach((k, i) => { const s = document.createElement("span"); s.textContent = NOTES[k][1]; if (i < step) s.className = "done"; if (i === step) s.className = "next"; meter.appendChild(s); }); }
  function placeRing() {
    const ring = $("play-drum-ring"); if (!ring) return;
    if (step < 0 || step >= TUNE.length) { ring.setAttribute("opacity", 0); return; }
    const p = playable[TUNE[step]]; ring.setAttribute("cx", p.x); ring.setAttribute("cy", p.y); ring.setAttribute("opacity", 1);
  }
  function hit(key) {
    tone(NOTES[key][0]); const p = playable[key]; p.el.classList.add("hot"); setTimeout(() => p.el.classList.remove("hot"), 170);
    if (step < 0) return;
    if (key === TUNE[step]) {
      step++; renderMeter();
      if (step >= TUNE.length) { $("play-status").textContent = ""; $("win").classList.add("show"); placeRing(); step = -1; return; }
      $("play-status").textContent = step < 4 ? "Oui ! Continuez sur la languette entourée." : step < 8 ? "Vous la reconnaissez ?" : "Plus que " + (TUNE.length - step) + " notes…";
    } else { $("play-status").textContent = "Joli quand même ! Touchez la languette entourée en doré."; }
    placeRing();
  }
  $("guide-start").addEventListener("click", () => { step = 0; $("win").classList.remove("show"); renderMeter(); placeRing(); $("play-status").textContent = "Touchez la languette 1 entourée en doré."; $("guide-start").textContent = "Recommencer"; });

  // ----- Prix, options -----
  const SIZES = {
    25: { name: "Essentiel · 25 cm", price: 119.90, ref: 199.90, colors: ["Vert d'eau"], scale: 0.72 },
    30: { name: "Plus · 30 cm", price: 139.90, ref: 234.90, colors: ["Vert d'eau", "Bleu marine"], scale: 0.86 },
    33: { name: "Grand · 33 cm", price: 169.90, ref: 284.90, colors: ["Bleu marine"], scale: 1 }
  };
  // Prix et couleurs lus sur la fiche Shopify : un changement de prix dans l'admin se retrouve ici.
  const VARIANTS = (window.SN && SN.variants) || [];
  Object.keys(SIZES).forEach((k) => {
    const vs = VARIANTS.filter((v) => parseInt(v.option1, 10) === Number(k));
    if (!vs.length) return;
    SIZES[k].price = vs[0].price / 100;
    SIZES[k].ref = (vs[0].compare_at_price || vs[0].price) / 100;
    SIZES[k].colors = vs.map((v) => v.option2);
  });
  function currentVariant() {
    const size = document.querySelector("input[name=size]:checked").value;
    const color = (document.querySelector(".swatch[aria-pressed=true]") || {}).getAttribute?.("aria-label");
    return VARIANTS.find((v) => parseInt(v.option1, 10) === Number(size) && v.option2 === color) || VARIANTS.find((v) => parseInt(v.option1, 10) === Number(size));
  }
  function syncForm() {
    const v = currentVariant();
    if (v) $("sn-variant").value = v.id;
    $("sn-qty").value = $("duo").checked ? 2 : 1;
    $("sn-gift").disabled = !$("giftcard").checked;
  }
  const BONUS = 29.90 + 9.90;
  const eur = (v) => v.toFixed(2).replace(".", ",") + " €";
  const swatches = [...document.querySelectorAll(".swatch")];
  function current() { return SIZES[document.querySelector("input[name=size]:checked").value]; }
  function update() {
    const s = current(); const duo = $("duo").checked; const total = s.price + (duo ? s.price * 0.8 : 0);
    $("price-now").textContent = eur(s.price);
    $("price-was").textContent = eur(s.ref); $("price-save").textContent = "−" + Math.round((1 - s.price / s.ref) * 100) + " %";
    $("save-eur").textContent = eur(s.ref - s.price) + " d'économie";
    $("split").textContent = "ou 4 × " + eur(s.price / 4) + " avec PayPal, ou en plusieurs fois avec Klarna, selon éligibilité";
    $("perday").textContent = "Moins de " + eur(Math.ceil(s.price / 365 * 100) / 100) + " par jour sur un an";
    $("pack-name").textContent = s.name; $("pack-price").textContent = eur(s.price); $("pack-now").textContent = eur(total);
    $("duo-price").textContent = "+ " + eur(s.price * 0.8);
    ["cta-price", "final-price", "win-price", "gift-price"].forEach((id) => { $(id).textContent = eur(total); });
    $("s-name").textContent = s.name + (duo ? " × 2" : ""); $("s-price").textContent = eur(total) + " · livraison offerte";
    $("size-hint").textContent = s.scale < 0.8 ? "Recommandé pour débuter" : s.scale < 1 ? "Plus de notes, son plus ample" : "Le son le plus profond";
    swatches.forEach((w) => { const ok = s.colors.includes(w.getAttribute("aria-label")); w.hidden = !ok; if (!ok) w.setAttribute("aria-pressed", "false"); });
    if (!swatches.some((w) => !w.hidden && w.getAttribute("aria-pressed") === "true")) swatches.find((w) => !w.hidden).setAttribute("aria-pressed", "true");
    const sel = swatches.find((w) => w.getAttribute("aria-pressed") === "true");
    $("color-name").textContent = sel.getAttribute("aria-label");
    if (drumColor !== sel.dataset.color) { drumColor = sel.dataset.color; topDrum($("play-drum"), true); topDrum($("phone-drum"), false); placeRing(); }
    showVariant(document.querySelector("input[name=size]:checked").value, sel.getAttribute("aria-label"));
    syncForm();
  }
  // Photos du modèle choisi (une série par taille et couleur)
  const PICS = { "25|Vert d'eau": "25g", "30|Vert d'eau": "30g", "30|Bleu marine": "30b", "33|Bleu marine": "33b" };
  let shownPic = null;
  function showVariant(size, color) {
    const v = PICS[size + "|" + color] || "25g";
    document.querySelector("#size-30 ~ .ico .mini").src = SN.assets + "v-" + (color === "Vert d'eau" ? "30g" : "30b") + "-mini.jpg";
    if (v === shownPic) return;
    const src = { dessus: SN.assets + "v-" + v + "-dessus.jpg", boite: SN.assets + "v-" + v + "-boite.jpg", profil: SN.assets + "v-" + v + "-profil.jpg" };
    document.querySelectorAll("img[data-v]").forEach((img) => { img.src = src[img.dataset.v]; });
    const g = $("slides"), r = g.getBoundingClientRect();
    if (shownPic && r.bottom > 80 && r.top < innerHeight - 80) g.scrollTo({ left: g.clientWidth, behavior: "smooth" });
    shownPic = v;
  }
  document.querySelectorAll("input[name=size]").forEach((r) => r.addEventListener("change", update));
  swatches.forEach((w) => w.addEventListener("click", () => { swatches.forEach((x) => x.setAttribute("aria-pressed", "false")); w.setAttribute("aria-pressed", "true"); update(); }));
  $("duo").addEventListener("change", update);
  $("giftcard").addEventListener("change", syncForm);
  $("value-toggle").addEventListener("click", (e) => { const d = $("value-detail"); d.hidden = !d.hidden; e.currentTarget.setAttribute("aria-expanded", String(!d.hidden)); e.currentTarget.textContent = d.hidden ? "voir le détail" : "masquer"; });

  // ----- Livraison et Noël -----
  function addBusinessDays(d, n) { const r = new Date(d); let added = 0; while (added < n) { r.setDate(r.getDate() + 1); const wd = r.getDay(); if (wd !== 0 && wd !== 6) added++; } return r; }
  const fmt = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long" });
  const today = new Date();
  $("d-min").textContent = fmt.format(addBusinessDays(today, 2)); $("d-max").textContent = fmt.format(addBusinessDays(today, 5));
  const deadline = new Date(today.getFullYear(), 11, 15, 23, 59, 59);
  function tick() {
    const ms = deadline - new Date();
    if (ms <= 0) { $("countdown").hidden = true; $("xmas-line").textContent = ""; return; }
    const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
    $("cd-d").textContent = String(d).padStart(2, "0"); $("cd-h").textContent = String(h).padStart(2, "0"); $("cd-m").textContent = String(m).padStart(2, "0");
    $("countdown").hidden = d > 21;
    $("xmas-line").textContent = d > 21 ? "Livré avant Noël pour toute commande passée avant le 15 décembre." : "Livré avant Noël : plus que " + d + " jours pour commander.";
  }
  tick(); setInterval(tick, 30000);

  // ----- Panier -----
  function toast(msg) { const t = $("toast"); t.textContent = msg; t.hidden = false; clearTimeout(toast.k); toast.k = setTimeout(() => { t.hidden = true; }, 2600); }
  // Ajout au panier puis passage direct au paiement (une seule étape de moins pour le client).
  async function addAndCheckout(btn) {
    const v = currentVariant();
    if (!v) { toast("Choisissez une taille."); return; }
    btn.setAttribute("aria-busy", "true");
    const props = $("giftcard").checked ? { "Pour offrir": "Oui" } : {};
    try {
      const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: v.id, quantity: $("duo").checked ? 2 : 1, properties: props }] }) });
      if (!r.ok) throw new Error(String(r.status));
      location.href = "/checkout";
    } catch (e) {
      btn.removeAttribute("aria-busy");
      toast("Un souci est survenu, réessayez dans un instant.");
    }
  }
  ["add", "add-final", "add-sticky", "add-win", "add-gift"].forEach((id) => { const b = $(id); if (b) b.addEventListener("click", () => addAndCheckout(b)); });
  const cartLink = document.querySelector("a.cart");
  if (cartLink) cartLink.addEventListener("click", (e) => {
    e.preventDefault();
    if ((Number(($("cart-count") || {}).textContent) || 0) > 0) { location.href = "/checkout"; return; }
    toast("Votre panier est vide : choisissez votre taille.");
    document.querySelector(".sizes").scrollIntoView({ behavior: "smooth", block: "center" });
  });

  // ----- Barre collante -----
  const mainCta = $("add");
  // Avant le choix de taille, la barre montre le prix et mène au choix ; après, elle ajoute au panier.
  const stickyBtn = $("add-sticky"); let passed = false;
  const io = new IntersectionObserver(([e]) => { passed = e.boundingClientRect.top < 0; $("sticky").classList.toggle("show", !e.isIntersecting); document.body.classList.toggle("cta-away", !e.isIntersecting && passed); stickyBtn.textContent = passed ? "Ajouter au panier" : "Choisir ma taille"; }, { threshold: 0 });
  stickyBtn.addEventListener("click", (ev) => { if (passed) return; ev.stopImmediatePropagation(); document.querySelector("input[name=size]").closest("label").scrollIntoView({ behavior: "smooth", block: "center" }); }, true);
  io.observe(mainCta);

  // ----- Un avis de la boutique sous le bouton d'achat (lu dans le bloc d'avis, rien n'est écrit ici) -----
  (function pickQuote(tries) {
    const revs = [...document.querySelectorAll("#judgeme_product_reviews .jdgm-rev")];
    if (!revs.length) { if (tries > 0) setTimeout(() => pickQuote(tries - 1), 1500); return; }
    const txt = (r) => ((r.querySelector(".jdgm-rev__body") || {}).textContent || "").trim().replace(/\s+/g, " ");
    const r = revs.find((x) => { const n = txt(x).length; return n >= 60 && n <= 260; }) || revs[0];
    let t = txt(r); if (!t) return; if (t.length > 200) t = t.slice(0, t.lastIndexOf(" ", 190)) + "…";
    const rating = r.querySelector(".jdgm-rev__rating");
    const score = Math.min(5, Math.max(1, Number(rating && rating.getAttribute("data-score")) || 5));
    $("quote-stars").textContent = "★★★★★".slice(0, score) + "☆☆☆☆☆".slice(0, 5 - score);
    $("quote-text").textContent = "« " + t + " »";
    $("quote-name").textContent = ((r.querySelector(".jdgm-rev__author") || {}).textContent || "").trim();
    $("quote").hidden = false;
  })(8);

  // ----- Bienvenue -10 % -----
  let shown = false; try { shown = localStorage.getItem("serenote-welcome") === "1"; } catch (e) {}
  function openWelcome() { if (shown) return; shown = true; $("welcome").hidden = false; try { localStorage.setItem("serenote-welcome", "1"); } catch (e) {} }
  // Seulement quand le visiteur s'apprête à partir : souris vers la barre du navigateur, ou long retour en arrière sur téléphone.
  document.addEventListener("mouseout", (e) => { if (!e.relatedTarget && e.clientY <= 0) openWelcome(); });
  let lastY = 0, upRun = 0; const t0 = Date.now();
  window.addEventListener("scroll", () => { const y = window.scrollY; upRun = y < lastY ? upRun + (lastY - y) : 0; lastY = y; if (innerWidth < 920 && upRun > 700 && Date.now() - t0 > 30000) openWelcome(); }, { passive: true });
  $("w-close").addEventListener("click", () => { $("welcome").hidden = true; });
  $("w-form").addEventListener("submit", async (e) => {
    e.preventDefault();
    const f = e.currentTarget;
    try { await fetch(f.action, { method: "POST", body: new FormData(f), headers: { Accept: "text/html" } }); } catch (err) {}
    f.hidden = true;
    $("w-title").innerHTML = "Votre code : <span class=\"code\">BIENVENUE10</span>";
    $("w-text").textContent = "−10 % sur votre première commande, à saisir au paiement.";
  });


  // ----- Galerie -----
  const slides = $("slides"), dots = $("dots"), slideEls = [...slides.children];
  slideEls.forEach(() => dots.appendChild(document.createElement("span")));
  function activeIndex() { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); }
  function syncGallery() {
    const i = activeIndex();
    [...dots.children].forEach((d, k) => d.classList.toggle("on", k === i));
    document.querySelectorAll(".thumb").forEach((bt, k) => bt.setAttribute("aria-current", k === i ? "true" : "false"));
    slideEls.forEach((s, k) => { const v = s.querySelector("video"); if (!v) return; if (k === i) v.play().catch(() => {}); else v.pause(); });
  }
  slides.addEventListener("scroll", () => { clearTimeout(syncGallery.k); syncGallery.k = setTimeout(syncGallery, 80); }, { passive: true });
  document.querySelectorAll(".thumb").forEach((bt) => bt.addEventListener("click", () => { slides.scrollTo({ left: slides.clientWidth * +bt.dataset.i, behavior: "smooth" }); }));
  syncGallery();
  const hv = $("hero-video");
  $("sound").addEventListener("click", (e) => { hv.muted = !hv.muted; if (!hv.muted) { hv.currentTime = 0; hv.play().catch(() => {}); } e.currentTarget.setAttribute("aria-pressed", String(!hv.muted)); e.currentTarget.querySelector("span").textContent = hv.muted ? "Écouter le son" : "Son activé"; });

  // ----- Vidéos courtes : lecture quand visibles, son au toucher -----
  const reelIO = new IntersectionObserver((entries) => entries.forEach((en) => { const v = en.target; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: 0.6 });
  document.querySelectorAll(".reel video, .petvid").forEach((v) => reelIO.observe(v));
  document.querySelectorAll(".reel .unmute").forEach((bt) => bt.addEventListener("click", () => {
    const v = bt.parentElement.querySelector("video"); const turnOn = v.muted;
    document.querySelectorAll(".reel video").forEach((x) => { x.muted = true; });
    document.querySelectorAll(".reel .unmute").forEach((x) => x.setAttribute("aria-pressed", "false"));
    if (turnOn) { v.muted = false; v.currentTime = 0; v.play().catch(() => {}); bt.setAttribute("aria-pressed", "true"); }
  }));

  // ----- Zoom des photos -----
  const lb = $("lightbox");
  document.querySelectorAll("img[data-zoom]").forEach((img) => img.addEventListener("click", () => { $("lb-img").src = img.src; $("lb-img").alt = img.alt; lb.hidden = false; }));
  lb.addEventListener("click", () => { lb.hidden = true; });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") lb.hidden = true; });

  // ----- Avis -----
  // La source de chaque avis est affichée sur la page. Textes recopiés mot pour mot, sans correction.
  // "testeur" : personnes de l'entourage qui ont essayé le tambour avant l'ouverture (source déclarée par Alex le 04/10/2026). Pas des achats.
  // "achat" : acheteurs vérifiés importés de Judge.me sur Shopify. Format : { source: "achat", name: "Prénom N.", rating: 1 à 5, date: "AAAA-MM-JJ", size: "25 cm", text: "..." }
  const REVIEWS = [];
  const STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.3l-5.6 2.9 1.1-6.3-4.6-4.4 6.3-.9z"/></svg>';
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  const stars = (n) => Array.from({ length: 5 }, (_, i) => `<span class="${i < Math.round(n) ? "on" : ""}">${STAR}</span>`).join("");
  const ARROW = '<span class="arr" aria-hidden="true">→</span>';
  const ico = (d) => `<svg class="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
  function renderReviews(list = REVIEWS) {
    const box = $("reviews"), n = list.length;
    $("rating").hidden = true;
    box.classList.toggle("has", n > 0);
    if (!n) {
      box.innerHTML = `<div class="rv-empty"><span class="rv-stars">${stars(0)}</span><h3>Les premiers avis arrivent avec les premières livraisons.</h3><p>Ce modèle vient de sortir chez Sérénote. Seuls les clients qui ont reçu leur tambour peuvent laisser un avis, et nous les publions tous, même les moins bons.</p><button class="rv-write" type="button">Écrire un avis</button></div>
        <div class="rv-verify"><p>En attendant, jugez par vous-même</p>
          <a href="#h-play">${ico('<path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>')}<span><b>Jouez une mélodie ici</b>Sur cette page, sans rien installer.</span>${ARROW}</a>
          <a href="#h-pledge">${ico('<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v4h4"/>')}<span><b>Essayez-le 30 jours</b>Retour gratuit, remboursé sans justification.</span>${ARROW}</a>
          <a href="#h-faq">${ico('<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12Z"/>')}<span><b>Posez-nous vos questions</b>Une vraie personne répond sous 24&nbsp;h.</span>${ARROW}</a>
        </div>`;
      box.querySelector(".rv-write").addEventListener("click", () => toast("Le lien pour donner votre avis vous arrive par email après la livraison."));
      return;
    }
    const avg = list.reduce((s, r) => s + r.rating, 0) / n, avgTxt = avg.toFixed(1).replace(".", ",");
    const buyers = list.filter((r) => r.source === "achat").length, testers = n - buyers;
    const rating = $("rating"); rating.innerHTML = `<span class="rv-stars sm">${stars(avg)}</span><b>${avgTxt}</b> (${n} avis)`; rating.hidden = false;
    const bars = [5, 4, 3, 2, 1].map((k) => { const c = list.filter((r) => r.rating === k).length; return `<div class="rv-bar"><span>${k}</span><i style="--w:${(c / n) * 100}%"></i><span>${c}</span></div>`; }).join("");
    const who = testers ? `${n} avis` : `${n} avis d'acheteurs vérifiés`;
    // Une seule mention de la source des premiers avis, sous la note (pas de badge sur chaque avis).
    const note = !testers ? "" : `<p class="rv-note">${buyers ? "Les avis sans la mention « achat vérifié » viennent" : "Ces premiers avis viennent"} de proches qui ont essayé le tambour avant l'ouverture de la boutique. Les avis d'acheteurs s'ajoutent ici après chaque livraison, et nous les publions tous, même les moins bons.</p>`;
    const day = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" });
    const meta = (r) => r.source === "achat" ? `<div class="rv-meta"><b>${esc(r.name)}</b> · achat vérifié · ${esc(r.size)} · ${day.format(new Date(r.date))}</div>` : "";
    const SHOWN = 6;
    box.innerHTML = `<div class="rv-sum"><div class="big">${avgTxt}</div><span class="rv-stars">${stars(avg)}</span><p>${who}</p>${bars}${note}</div>
      <div class="rv-list">${list.map((r, i) => `<article class="rv-card"${i >= SHOWN ? " hidden" : ""}><span class="rv-stars sm">${stars(r.rating)}</span><p>${esc(r.text)}</p>${meta(r)}</article>`).join("")}${n > SHOWN ? `<button class="rv-more" type="button">Voir les ${n} avis</button>` : ""}</div>`;
    const more = box.querySelector(".rv-more");
    if (more) more.addEventListener("click", () => { box.querySelectorAll(".rv-card[hidden]").forEach((c) => { c.hidden = false; }); more.remove(); });
  }

  // ----- Démarrage -----
  topDrum($("play-drum"), true); topDrum($("phone-drum"), false); renderMeter(); update();

  // ----- En-tête : ombre au défilement, menu, messages qui tournent -----
  const hdr = $("hdr"), drawer = $("drawer"), burger = $("burger");
  const onScroll = () => hdr.classList.toggle("scrolled", scrollY > 8);
  addEventListener("scroll", onScroll, { passive: true }); onScroll();
  function menu(open) {
    if (open) drawer.style.setProperty("--hdr", hdr.getBoundingClientRect().bottom + "px");
    drawer.classList.toggle("open", open); burger.setAttribute("aria-expanded", String(open));
    document.documentElement.style.overflow = open ? "hidden" : "";
  }
  burger.addEventListener("click", () => menu(!drawer.classList.contains("open")));
  $("veil").addEventListener("click", () => menu(false));
  drawer.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => menu(false)));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") menu(false); });
  const msgs = [...document.querySelectorAll("#announce .msg")]; let mi = 0;
  function nextMsg() {
    if (innerWidth >= 1180) return; // tous les messages sont visibles
    msgs[mi].classList.remove("on"); mi = (mi + 1) % msgs.length; msgs[mi].classList.add("on");
  }
  if (!matchMedia("(prefers-reduced-motion: reduce)").matches) setInterval(nextMsg, 3800);
})();
